<template>
  <div>
    <el-dialog
      :title="this.value.isCreate ? '新增角色' : '编辑角色'"
      center
      :visible.sync="visible"
      @closed="onClosed"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="750px"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="200px"
        size="mini"
      >
        <el-form-item label="名称：">
          <el-input
            :disabled="!this.value.isCreate"
            v-model="form.name"
            style="width: 300px"
            clearable
          ></el-input>
        </el-form-item>

        <el-form-item label="权限：" prop="status">
          <el-select
            multiple
            clearable
            v-model="form.privileges"
            placeholder="请选择"
            style="width: 300px"
          >
            <el-option
              v-for="item in privilegeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="submit()" style="margin-left: 30px">{{
          this.value.isCreate ? "确定" : "保存"
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";

export default {
  data() {
    return {
      visible: true,
      form: {
        name: "",
        privileges: [],
      },
      privilegeOptions: [],
      rules: {
        name: [{ required: true, message: " ", trigger: "blur" }],
      },
    };
  },

  props: {
    value: Object,
  },

  components: {},

  async created() {
    for (let privilege of await this.$bizutil.loadPrivileges()) {
      this.privilegeOptions.push({
        label: privilege,
        value: privilege,
      });
    }

    if (!this.value.isCreate) {
      this.form = this.value.oldData;
    }
  },

  methods: {
     /**
     * 提交表单
     */
    submit() {
      if (this.value.isCreate) {
        this.add();
      } else {
        this.update();
      }
    },

    /**
     * 新增
     */
    async add() {
      if (this.form.name.trim() === "") {
        this.$alert("请输入角色名称");
        return;
      }

      try {
        // 弹确认框
        await this.$confirm(`确认新增角色“${this.form.name}”？`);

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/account/manageRoles`,
            {
              action: "create",
              create: {
                role: {
                  name: this.form.name.trim(),
                  privileges: this.form.privileges,
                }
              }
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "添加成功",
          type: "success",
        });

        // 关闭当前对话框
        this.visible = false;
      } catch (e) {}
    },

    async update() {
      try {
        // 弹确认框
        await this.$confirm(`确认更新角色“${this.form.name}”？`);

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/account/manageRoles`,
            {
              action: "update",
              update: {
                role: {
                  name: this.form.name,
                  privileges: this.form.privileges,
                }
              }
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "更新成功",
          type: "success",
        });

        // 关闭当前对话框
        this.visible = false;
      } catch (e) {}
    },

    onClosed() {
      // 向父组件抛出事件
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.link-button {
  padding-left: 10px;
  color: rgb(37, 148, 240);
  cursor: pointer;
}
</style>